import { Route, Switch } from "react-router-dom";
import ListagemPerfis from "./Listagem";
import PerfilDetalhes from "./Detalhes";

function PerfilPages() {
  return (
    <Switch>
      <Route exact path="/cadastros/perfis" component={ListagemPerfis} />
      <Route exact path="/cadastros/perfis/novo" component={PerfilDetalhes} />
      <Route path="/cadastros/perfis/:id" component={PerfilDetalhes} />
    </Switch>
  );
}

export default PerfilPages;
